document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-related-products]');
  if (!container) return;

  var url = container.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(function (response) {
      if (!response.ok) throw new Error('Recommendations fetch failed');
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fetchedContainer = doc.querySelector('[data-related-products]');
      if (fetchedContainer) {
        container.innerHTML = fetchedContainer.innerHTML;
      }
    })
    .catch(function (error) {
      // Leave the section empty rather than showing a broken/partial state.
      console.error('Related products fetch failed:', error);
    });
});
